import * as React from 'react';
import { noop } from 'vet-bones/utils';

import { ProjectVirtualGraph } from 'src/store/state/projects';

type LocalProjectVirtualGraph = ProjectVirtualGraph & {
  errors?: Array<{ message: string }>;
  isSettingsOpenKey?: number;
};

export type LocalVirtualGraphValue = [
  LocalProjectVirtualGraph | null,
  React.Dispatch<React.SetStateAction<LocalProjectVirtualGraph>>
];

export const LocalVirtualGraphContext =
  React.createContext<LocalVirtualGraphValue>([null, noop]);

export const useLocalVirtualGraph = () => {
  const localVirtualGraph = React.useContext(LocalVirtualGraphContext);
  return localVirtualGraph;
};

export const useLocalVirtualGraphValue = (
  virtualGraph: ProjectVirtualGraph
): LocalVirtualGraphValue => {
  const [localVirtualGraph, setLocalVirtualGraph] =
    React.useState<LocalProjectVirtualGraph>({ ...virtualGraph });
  return [localVirtualGraph, setLocalVirtualGraph];
};
